import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { StudentProvider } from "@/context/StudentContext";
import { Navigate } from "react-router-dom";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/public/Home";
import Programs from "@/pages/public/Programs";
import Contact from "@/pages/public/Contact";
import Schedule from "@/pages/public/Schedule";
import Intake from "@/pages/public/Intake";
import Confirmation from "@/pages/public/Confirmation";

import AdminLogin from "@/pages/admin/AdminLogin";
import AuthCallback from "@/pages/admin/AuthCallback";
import Dashboard from "@/pages/admin/Dashboard";
import Applicants from "@/pages/admin/Applicants";
import ApplicantProfile from "@/pages/admin/ApplicantProfile";
import AdminsManage from "@/pages/admin/AdminsManage";
import Trainers from "@/pages/admin/Trainers";
import Students from "@/pages/admin/Students";
import StudentRecord from "@/pages/admin/StudentRecord";
import DocumentLibrary from "@/pages/admin/DocumentLibrary";
import CourseMaterials from "@/pages/admin/CourseMaterials";
import Quizzes from "@/pages/admin/Quizzes";
import Reports from "@/pages/admin/Reports";
import PortalSettings from "@/pages/admin/PortalSettings";
import TrainerAvailability from "@/pages/admin/TrainerAvailability";
import TrainerCalendar from "@/pages/admin/TrainerCalendar";
import VerifyCertificate from "@/pages/public/VerifyCertificate";
import StudentLogin from "@/pages/student/StudentLogin";
import StudentSetPassword from "@/pages/student/StudentSetPassword";
import StudentMagic from "@/pages/student/StudentMagic";
import StudentPortal from "@/pages/student/StudentPortal";

const AdminHome = () => {
  const { admin } = useAuth();
  return ["primary", "admin"].includes(admin?.role) ? <Dashboard /> : <Navigate to="/admin/students" replace />;
};
const P = (el) => <ProtectedRoute>{el}</ProtectedRoute>;

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/programs" element={<Programs />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/schedule" element={<Schedule />} />
      <Route path="/intake" element={<Intake />} />
      <Route path="/confirmation" element={<Confirmation />} />

      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={P(<AdminHome />)} />
      <Route path="/admin/students" element={P(<Students />)} />
      <Route path="/admin/students/:sid" element={P(<StudentRecord />)} />
      <Route path="/admin/library" element={P(<DocumentLibrary />)} />
      <Route path="/admin/materials" element={P(<CourseMaterials />)} />
      <Route path="/admin/quizzes" element={P(<Quizzes />)} />
      <Route path="/admin/reports" element={P(<Reports />)} />
      <Route path="/admin/portal-settings" element={P(<PortalSettings />)} />
      <Route path="/admin/trainers/:tid/availability" element={P(<TrainerAvailability />)} />
      <Route path="/admin/my-availability" element={P(<TrainerAvailability self />)} />
      <Route path="/admin/trainer-calendar" element={P(<TrainerCalendar />)} />
      <Route path="/verify/:certId" element={<VerifyCertificate />} />
      <Route path="/student/login" element={<StudentLogin />} />
      <Route path="/student/activate" element={<StudentSetPassword mode="activate" />} />
      <Route path="/student/reset" element={<StudentSetPassword mode="reset" />} />
      <Route path="/student/magic" element={<StudentMagic />} />
      <Route path="/student" element={<StudentPortal />} />
      <Route path="/admin/applicants" element={<ProtectedRoute><Applicants /></ProtectedRoute>} />
      <Route path="/admin/applicants/:id" element={<ProtectedRoute><ApplicantProfile /></ProtectedRoute>} />
      <Route path="/admin/trainers" element={<ProtectedRoute><Trainers /></ProtectedRoute>} />
      <Route path="/admin/administrators" element={<ProtectedRoute><AdminsManage /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <StudentProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
        </StudentProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
